import { render, staticRenderFns } from "./formSetting.vue?vue&type=template&id=7d36b4bb&scoped=true&"
import script from "./formSetting.vue?vue&type=script&lang=js&"
export * from "./formSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d36b4bb",
  null
  
)

export default component.exports